import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { Accordion } from './Accordion';
export function Tomos() {
  const [openIndex, setOpenIndex] = useState<number>(0);
  const tomos = [{
    num: 'Tomo 1',
    title: 'Cimientos',
    icon: '🤲',
    desc: 'Todo lo que un alumno necesita para empezar — parámetros del LSA, abecedario, números, saludos y presentaciones.',
    result: 'Tus alumnos arrancan con base sólida desde la primera clase, sin confusión ni retrocesos.'
  }, {
    num: 'Tomo 2',
    title: 'Familia y Emociones',
    icon: '👨‍👩‍👧',
    desc: 'Vocabulario de familia completa, las 30 emociones fundamentales, días, meses y clima.',
    result: 'Tus alumnos conectan emocionalmente con el LSA y empiezan a usarlo en conversaciones reales.'
  }, {
    num: 'Tomo 3',
    title: 'Vida Cotidiana',
    icon: '🏠',
    desc: 'El hogar, alimentos argentinos, ropa, ciudad, transporte y rutinas del día a día.',
    result: 'Tus alumnos aplican el LSA en situaciones reales de la vida argentina desde el primer momento.'
  }, {
    num: 'Tomo 4',
    title: 'Mundo Exterior',
    icon: '🌐',
    desc: 'Trabajo, salud, tecnología, trámites, banco y tiempo libre en LSA.',
    result: 'Tus alumnos pueden comunicarse en contextos formales y profesionales sin depender de nadie.'
  }, {
    num: 'Tomo 5',
    title: 'Gramática y Cultura Sorda',
    icon: '📖',
    desc: 'Gramática visual del LSA, clasificadores, estructura de oraciones y cultura Sorda argentina.',
    result: 'Tus alumnos dejan de señar palabras sueltas y empiezan a hablar LSA de verdad.'
  }, {
    num: 'Tomo 6',
    title: 'Situaciones Reales',
    icon: '💬',
    desc: 'Diálogos completos para 10 situaciones reales — calle, salud, trabajo, familia, emergencias y más.',
    result: 'Tus alumnos practican conversaciones completas y ganan confianza para usar el LSA afuera del aula.'
  }, {
    num: 'Tomo 7',
    title: 'Maestría y Diccionario Visual',
    icon: '⭐',
    desc: 'Diccionario visual de 500+ señas, señas compuestas, expresiones idiomáticas y narrativa avanzada.',
    result: 'Tenés un diccionario completo para consultar en cualquier clase, en segundos.'
  }];
  const includes = ['Material listo para usar con alumnos de cualquier nivel', 'Progresión didáctica clara clase por clase', 'Ejercicios y actividades para cada tema', '100% basado en LSA argentino 2026'];
  return <section id="tomos" className="bg-lsa-dark text-white py-12 px-5" data-id="element-260">
      <div className="max-w-xl mx-auto" data-id="element-261">
        <div className="flex justify-center mb-6" data-id="element-262">
          <div className="bg-white/10 border border-white/20 rounded-full px-4 py-1.5 text-xs font-semibold tracking-wide flex items-center gap-2" data-id="element-263">
            <span data-id="element-264">📦</span> Sistema Completo para Profesores
          </div>
        </div>

        <h2 className="text-[28px] font-bold text-center mb-3 leading-tight" data-id="element-265">
          7 tomos. +2000 señas. Tus clases resueltas.
        </h2>
        <p className="text-center text-white/80 text-[16px] mb-10" data-id="element-266">
          Material didáctico progresivo listo para usar con tus alumnos.
        </p>

        <div className="mb-10" data-id="element-267">
          {tomos.map((tomo, index) => <Accordion key={index} theme="dark" isOpen={openIndex === index} onToggle={() => setOpenIndex(openIndex === index ? -1 : index)} title={<div className="flex items-center gap-3" data-id="element-269">
                  <span className="text-xl" data-id="element-270">{tomo.icon}</span>
                  <span data-id="element-271">
                    <span className="text-lsa-celeste font-bold" data-id="element-272">
                      {tomo.num}
                    </span>{' '}
                    · {tomo.title}
                  </span>
                </div>} data-id="element-268">
              <div className="pt-2 pb-1 space-y-3" data-id="element-273">
                <p className="text-[14px] text-white/80 leading-relaxed" data-id="element-274">
                  {tomo.desc}
                </p>
                <p className="italic text-white/90 text-[14px] border-l-2 border-lsa-celeste pl-3" data-id="element-275">
                  <span className="font-semibold text-lsa-celeste not-italic" data-id="element-276">
                    Resultado:{' '}
                  </span>
                  {tomo.result}
                </p>
              </div>
            </Accordion>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white/5 border border-white/10 rounded-2xl p-5" data-id="element-277">
          <h3 className="font-bold text-[16px] mb-3 text-lsa-celeste" data-id="element-278">
            Cada tomo incluye:
          </h3>
          <ul className="grid grid-cols-1 gap-3" data-id="element-279">
            {includes.map((item, i) => <li key={i} className="flex items-center gap-2 text-[14px] text-white/90" data-id="element-280">
                <Check className="text-lsa-celeste shrink-0" size={18} data-id="element-281" />
                <span data-id="element-282">{item}</span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}